import React from 'react';
import { SectionCompare } from '../components';

const SectionCompareWrap = ({compareData, locale}) => {
  return (
    <div className='section-compare fvw'>
      {compareData.map(({ title, textUk, textSe, textEn, image, imageAlt, icon, alt, reverse }, idx) => (
        <SectionCompare
          key={idx}
          title={title}
          textUk={textUk}
          textSe={textSe}
          textEn={textEn}
          image={image}
          imageAlt={imageAlt}
          icon={icon}
          alt={alt}
          reverse={reverse}
          locale={locale} />
      ))}
    </div>
  );
}

export default SectionCompareWrap;
